module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAYAAAAPtVbGAAABQElEQVR42qzWPW7CMBQHcPM2JAoXyDmQAHWjA70BO7egCR+p1IG5IxvqEVrEwFKVW3TkBqiVEF//JxkpsmzzjGPpH5HE6Bc78UsqhyTpK6XekHdkpsppbWSO/CCDCpAVfjzpkxmSRwId5BOpI2ekRtiMkZ3uMEXSkgBuE+SPkQ3yXALUNoBcI4r0gW8L9BIIfBlAdj1JhY4mlAshcwTTImAiLmgoABoFYGR2IssfTejVAbUkgAuRQC19D24C3Hid+Ob7UV9tTe8ztEaWUkCC2KB/pCoFfNPlm7ogQIpwOyIn49hBuojojoW2D60MFAjwU9YNLUEUCKSOEpTeg9hqUep5GLwQhRa7G1AmQaSAC5rY+lMEIIYoEhBBjDQjAR80vNYurku9SMBV67hKPPBIPpCtfgvGAsUR/SIL/pC4CDAAkx5x418uFEYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/delete.png
// module id = KuaY
// module chunks = 1